import React from 'react';
import { Link, Outlet, useLocation } from 'react-router';

import { DesktopOutlined, FileDoneOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Layout, Menu, Select, theme } from 'antd';
import { ThemeOptions } from './shared/constants/enums';

const { Header, Content, Sider } = Layout;

type MenuItem = Required<MenuProps>['items'][number];

function getItem(label: React.ReactNode, key: React.Key, title: string, icon?: React.ReactNode, children?: MenuItem[]): MenuItem {
  return {
    key,
    title,
    icon,
    children,
    label,
  } as MenuItem;
}

const App: React.FC = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  (window as any).ncBoldPenguinQuotation = {
    quoteApplicationId: 'd3852920-0bda-40ba-893e-04726bfe022d',
    //bpApplicationId: '',
    //buttonClassName: 'test', // this must be set in order buttonText to be applied
    buttonText: 'Send to Bold Penguin',
    env: 'test', // possible values: test, prod
  };

  const handleThemeChange = (value: string) => {
    (window as any).REACT_APP_THEME = value;
    localStorage.setItem('userThemeReact', value);
    window.location.reload();
  };

  const currentTheme = localStorage.getItem('userThemeReact') || (window as any).REACT_APP_THEME;

  const items: MenuItem[] = [
    getItem(<Link to="/">Login</Link>, '/', 'Home', <DesktopOutlined />),
    getItem(
      <Link to="/bold-penguin-quotation">Bold Penguin Qoutation</Link>,
      '/bold-penguin-quotation',
      'Bold Penguin Qoutation',
      <DesktopOutlined />,
    ),
    getItem(<Link to="/nc-roam-subscription">Momentum Roam Subscription</Link>, '/nc-roam-subscription', 'Momentum Roam Subscription', <DesktopOutlined />),
    getItem(<Link to="/web-socket">Web Socket</Link>, '/web-socket', 'Web Socket', <DesktopOutlined />),
    getItem(<Link to="/user-activity-events">User Activity Events</Link>, '/user-activity-events', 'User Activity Events', <DesktopOutlined />),
    getItem(<Link to="/support-chat">Support Chat</Link>, '/support-chat', 'Support Chat', <DesktopOutlined />),
    getItem(
      <Link to="/smses">
        <span style={{ display: 'flex' }}>
          SMSes{' '}
          <style>
            {`
              @keyframes blink {
                0% { opacity: 1; }
                50% { opacity: 0; }
                100% { opacity: 1; }
              }
            `}
          </style>
          <span
            id="showNewSmsLabel"
            style={{
              fontSize: '12px',
              color: 'gray',
              display: 'inline',
              animation: 'blink 1s linear infinite',
            }}
          >
            New message
          </span>
        </span>
      </Link>,
      '/smses',
      'SMSes',
      <DesktopOutlined />,
    ),
    getItem(<Link to="/guideai-app-handler">Guide AI App</Link>, '/guideai-app-handler', 'Guide AI App', <DesktopOutlined />),
    getItem(<Link to='/esign-documents'>Rabbit Sign Documents</Link>, 'esign-documents', 'Rabbit Sign Documents', <FileDoneOutlined />),
    getItem(<Link to='/signature'>Signature</Link>, 'signature', 'Signature', <FileDoneOutlined />),
    getItem(<Link to='/system-message-edit'>System Message Edit</Link>, 'system-message-edit', 'System Message Edit', <FileDoneOutlined />),
  ];

  const routerLocation = useLocation();

  const selectedKey = routerLocation.pathname;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src="https://www.nowcerts.com/Resources/Images/intro/nowcerts-insurance-agency-management-system-identity-light.png?Momentum"
          id="logoImg"
          alt="Insurance Agency Management System Software Identity - NowCerts.com"
          style={{ maxWidth: '200px' }}
        />
      </Header>
      <Layout>
        <Sider width={300} style={{ background: colorBgContainer }}>
          <Select options={ThemeOptions} value={currentTheme} onChange={handleThemeChange} style={{ width: '100%' }} />
          <Menu selectedKeys={[selectedKey]} mode="inline" style={{ height: '100%', borderRight: 0 }} items={items} />
        </Sider>
        <Layout style={{ padding: '24px 24px 24px' }}>
          <Content
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default App;
